/**
 * Progressively enhances native <select id="SortBy"> / <select id="SortBy-mobile">
 * into a Babyboo-style custom dropdown, without touching facets.js logic.
 * Re-initializes automatically after AJAX facet re-renders.
 */
class CustomSortSelect {
  constructor(select) {
    this.select = select;
    this.select.classList.add('custom-sort-select-hidden');
    this.select.dataset.customSortInit = 'true';
    this.render();
  }

  render() {
    const wrapper = document.createElement('div');
    wrapper.className = 'custom-sort';

    const selectedOption = this.select.options[this.select.selectedIndex];

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'custom-sort__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    button.innerHTML = `
      <span class="custom-sort__label">${this.select.dataset.customLabel || 'Sort'}</span>
      <span class="svg-wrapper custom-sort__caret">${this.caretSvg()}</span>
    `;

  const list = document.createElement('ul');
    list.className = 'custom-sort__list';
    list.setAttribute('role', 'listbox');

    // Only show these 4 options, in this exact order, with custom labels —
    // matches Shopify's real sort_by values under the hood.
    const allowedSorts = [
      { value: 'created-descending', label: 'Newest' },
      { value: 'best-selling', label: 'Most Popular' },
      { value: 'price-ascending', label: 'Price Low - High' },
      { value: 'price-descending', label: 'Price High - Low' },
    ];

    allowedSorts.forEach((sortDef) => {
      const matchingOption = this.select.querySelector(`option[value="${sortDef.value}"]`);
      if (!matchingOption) return; // skip if this store doesn't have that sort option

      const item = document.createElement('li');
      item.className = 'custom-sort__item' + (matchingOption.selected ? ' is-active' : '');
      item.setAttribute('role', 'option');
      item.setAttribute('tabindex', '0');
      item.dataset.value = sortDef.value;
      item.textContent = sortDef.label;

      item.addEventListener('click', () => this.selectOption(sortDef.value, item, wrapper));
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.selectOption(sortDef.value, item, wrapper);
        }
      });

      list.appendChild(item);
    });

    wrapper.appendChild(button);
    wrapper.appendChild(list);

    // Insert OUTSIDE the .select container (not just after the <select>)
    // so we escape its fixed width/overflow rules, then hide that container entirely.
    const selectContainer = this.select.closest('.select') || this.select.parentElement;
    selectContainer.insertAdjacentElement('afterend', wrapper);
    selectContainer.style.display = 'none';

    button.addEventListener('click', () => this.toggle(wrapper, button));
    document.addEventListener('click', (event) => {
      if (!wrapper.contains(event.target)) this.close(wrapper, button);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close(wrapper, button);
    });

    this.wrapper = wrapper;
    this.button = button;
    this.list = list;
  }

  toggle(wrapper, button) {
    wrapper.classList.contains('is-open') ? this.close(wrapper, button) : this.open(wrapper, button);
  }

  open(wrapper, button) {
    wrapper.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
  }

  close(wrapper, button) {
    wrapper.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
  }

  selectOption(value, item, wrapper) {
    this.select.value = value;
    this.select.dispatchEvent(new Event('input', { bubbles: true }));
    this.select.dispatchEvent(new Event('change', { bubbles: true }));

    this.list.querySelectorAll('.custom-sort__item').forEach((el) => el.classList.remove('is-active'));
    item.classList.add('is-active');

    this.close(wrapper, this.button);
  }

  caretSvg() {
    return '<svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.2"/></svg>';
  }
}

function initCustomSort() {
  document.querySelectorAll('#SortBy, #SortBy-mobile').forEach((select) => {
    if (!select.dataset.customSortInit) new CustomSortSelect(select);
  });
}

document.addEventListener('DOMContentLoaded', initCustomSort);

// Re-run after facets.js swaps the .sorting / .mobile-facets__sort markup via AJAX
document.querySelectorAll('.sorting, .mobile-facets__sort').forEach((target) => {
  new MutationObserver(initCustomSort).observe(target, { childList: true, subtree: true });
});

// Safety net in case those containers aren't in the DOM yet on first paint
new MutationObserver(initCustomSort).observe(document.body, { childList: true, subtree: true });